__turbopack_context__.v({
  "authPhoneField": "LoginSignupModal-module__2jbc9a__authPhoneField",
  "backBtn": "LoginSignupModal-module__2jbc9a__backBtn",
  "closeBtn": "LoginSignupModal-module__2jbc9a__closeBtn",
  "errorText": "LoginSignupModal-module__2jbc9a__errorText",
  "fieldInput": "LoginSignupModal-module__2jbc9a__fieldInput",
  "fieldInputError": "LoginSignupModal-module__2jbc9a__fieldInputError",
  "fieldLabel": "LoginSignupModal-module__2jbc9a__fieldLabel",
  "fieldWrap": "LoginSignupModal-module__2jbc9a__fieldWrap",
  "formBody": "LoginSignupModal-module__2jbc9a__formBody",
  "formEyebrow": "LoginSignupModal-module__2jbc9a__formEyebrow",
  "formPanel": "LoginSignupModal-module__2jbc9a__formPanel",
  "formSubtitle": "LoginSignupModal-module__2jbc9a__formSubtitle",
  "formSubtitle2": "LoginSignupModal-module__2jbc9a__formSubtitle2",
  "formTitle": "LoginSignupModal-module__2jbc9a__formTitle",
  "formTitle2": "LoginSignupModal-module__2jbc9a__formTitle2",
  "formTitleNone": "LoginSignupModal-module__2jbc9a__formTitleNone",
  "formTitleOtp": "LoginSignupModal-module__2jbc9a__formTitleOtp",
  "formTitleSpan1": "LoginSignupModal-module__2jbc9a__formTitleSpan1",
  "formTitleSpan2": "LoginSignupModal-module__2jbc9a__formTitleSpan2",
  "formTopBar": "LoginSignupModal-module__2jbc9a__formTopBar",
  "legalText": "LoginSignupModal-module__2jbc9a__legalText",
  "legalTextDiv": "LoginSignupModal-module__2jbc9a__legalTextDiv",
  "modal": "LoginSignupModal-module__2jbc9a__modal",
  "modalDesktop": "LoginSignupModal-module__2jbc9a__modalDesktop",
  "modalMobile": "LoginSignupModal-module__2jbc9a__modalMobile",
  "otpGroup": "LoginSignupModal-module__2jbc9a__otpGroup",
  "otpInput": "LoginSignupModal-module__2jbc9a__otpInput",
  "otpInputFilled": "LoginSignupModal-module__2jbc9a__otpInputFilled",
  "overlay": "LoginSignupModal-module__2jbc9a__overlay",
  "primaryBtn": "LoginSignupModal-module__2jbc9a__primaryBtn",
  "primaryBtnActive": "LoginSignupModal-module__2jbc9a__primaryBtnActive",
  "primaryBtnDiv": "LoginSignupModal-module__2jbc9a__primaryBtnDiv",
  "promoContent": "LoginSignupModal-module__2jbc9a__promoContent",
  "promoFeature": "LoginSignupModal-module__2jbc9a__promoFeature",
  "promoFeatureText": "LoginSignupModal-module__2jbc9a__promoFeatureText",
  "promoFeatureTitle": "LoginSignupModal-module__2jbc9a__promoFeatureTitle",
  "promoIconWrap": "LoginSignupModal-module__2jbc9a__promoIconWrap",
  "promoImage": "LoginSignupModal-module__2jbc9a__promoImage",
  "promoOverlay": "LoginSignupModal-module__2jbc9a__promoOverlay",
  "promoPanel": "LoginSignupModal-module__2jbc9a__promoPanel",
  "promoTitle": "LoginSignupModal-module__2jbc9a__promoTitle",
  "resendBtn": "LoginSignupModal-module__2jbc9a__resendBtn",
  "resendText": "LoginSignupModal-module__2jbc9a__resendText",
  "resendTimer": "LoginSignupModal-module__2jbc9a__resendTimer",
  "root": "LoginSignupModal-module__2jbc9a__root",
  "rootDesktop": "LoginSignupModal-module__2jbc9a__rootDesktop",
  "rootMobile": "LoginSignupModal-module__2jbc9a__rootMobile",
  "sheetUp": "LoginSignupModal-module__2jbc9a__sheetUp",
});
